import React from "react";

export const Avatar = ({ initial, image, size = 32 }) => {
    return (
        <div 
            className="avatar" 
            style={{ 
                width: `${size}px`, 
                height: `${size}px`,
                fontSize: `${size/2}px`,
                backgroundColor: image ? "transparent" : getColorForLetter(initial),
                borderRadius: "50%",
                overflow: "hidden",
                flexShrink: 0,
                border: "none",
                boxShadow: "none",
                outline: "none"
            }}
        >
            {image ? (
                <img 
                    src={image} 
                    alt="User avatar" 
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                        borderRadius: "50%"
                    }}
                />
            ) : initial}
        </div>
    );
};

// Generate consistent colors based on initial
const getColorForLetter = (letter) => {
    if (!letter) return "#9370DB"; 
    
    const colors = [
        "#F44336", "#E91E63", "#9C27B0", "#673AB7", 
        "#3F51B5", "#2196F3", "#03A9F4", "#00BCD4",
        "#009688", "#4CAF50", "#8BC34A", "#CDDC39",
        "#FFC107", "#FF9800", "#FF5722", "#795548"
    ];
    
    const charCode = letter.charCodeAt(0);
    return colors[charCode % colors.length];
};